import { useEffect, useState } from "react";
import { preloadCompressedVehicleImage } from "@/utils/compressed-vehicle-image";

type ImageSource = { key?: string; url: string | null | undefined };

export function useCompressedImage(image: ImageSource | null | undefined) {
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(Boolean(image?.url));

  useEffect(() => {
    if (!image?.url) {
      setImageUrl(null);
      setIsLoading(false);
      return;
    }

    let isCancelled = false;
    setImageUrl(null);
    setIsLoading(true);

    void preloadCompressedVehicleImage({ key: image.key, url: image.url }).then((resolvedUrl) => {
      if (!isCancelled) {
        setImageUrl(resolvedUrl);
        setIsLoading(false);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [image?.key, image?.url]);

  return { imageUrl, isLoading };
}
